import SCardsSmall from '@core/slices/pages/cards-small/cards-small.vue';
import {
    Icon as CardsSmallIcon,
    Logo as CardsSmallLogo,
} from '@core/slices/pages/cards-small/stories.js';

export const Figma =
    'https://www.figma.com/design/eM4W6JS2MjG1gp5YhKoMp7Dd/Slices?node-id=49869-3824&t=7gQq4tnnFMCS1fTB-4';

export const Default = {
    args: {
        type: 'tabs',
        isWide: true,
        sticky: false,
        stickyTopOffset: 58,
        stickyMobileTopOffset: 0,
        title: 'Default navigation',
        lead: 'Basic tab switching example.',
        slices: [
            {
                info: {
                    caption: 'Acronis True Image 2020',
                    id: 'acronis-true-image-2020',
                },
                name: SCardsSmall,
                data: CardsSmallIcon.args,
            },
            {
                info: {
                    caption: 'Acronis Backup',
                    id: 'acronis-backup',
                },
                name: SCardsSmall,
                data: CardsSmallLogo.args,
            },
        ],
    },
};

export const Grouped = {
    args: {
        type: 'tabs',
        isWide: true,
        sticky: false,
        stickyTopOffset: 58,
        stickyMobileTopOffset: 0,
        title: 'Grouped navigation',
        lead: 'Tabs organized into logical groups.',
        groups: [
            {
                glyph: 'i-active-protection--16',
                text: 'Protection',
                id: 'success',
            },
            {
                glyph: 'i-analysis--16',
                text: 'Analytics',
                id: 'warning',
            },
        ],
        slices: [
            {
                info: {
                    caption: 'Acronis True Image 2020',
                    id: 'acronis-true-image-2020',
                },
                groupId: 'success',
                name: SCardsSmall,
                data: {
                    counter: true,
                    ...CardsSmallIcon.args,
                },
            },
            {
                info: {
                    caption: 'Acronis Backup',
                    id: 'acronis-backup',
                },
                groupId: 'success',
                name: SCardsSmall,
                data: {
                    counter: true,
                    ...CardsSmallLogo.args,
                },
            },
            {
                info: {
                    caption: 'Acronis Cloud Backup',
                    id: 'acronis-backup-cloud',
                },
                groupId: 'warning',
                name: SCardsSmall,
                data: {
                    counter: true,
                    ...CardsSmallIcon.args,
                },
            },
        ],
    },
};

export const Combined = {
    args: {
        type: 'combined',
        isWide: true,
        sticky: false,
        stickyTopOffset: 58,
        stickyMobileTopOffset: 0,
        title: 'Combined navigation',
        lead: 'Groups render multiple child slices together.',
        groups: [
            {
                glyph: 'i-active-protection--16',
                text: 'Protection',
                id: 'success',
            },
            {
                glyph: 'i-analysis--16',
                text: 'Analytics',
                id: 'warning',
            },
        ],
        slices: [
            {
                info: {
                    caption: 'Group with children',
                    id: 'test-group-1',
                },
                groupId: 'success',
                slices: [
                    {
                        info: {
                            caption: 'Acronis True Image 2020',
                            id: 'acronis-true-image-2020',
                        },
                        name: SCardsSmall,
                        data: CardsSmallIcon.args,
                    },
                    {
                        info: {
                            caption: 'Acronis Backup',
                            id: 'acronis-backup',
                        },
                        name: SCardsSmall,
                        data: CardsSmallLogo.args,
                    },
                ],
            },
            {
                info: {
                    caption: 'Flat group',
                    id: 'test-group-2',
                },
                groupId: 'warning',
                slices: [
                    {
                        info: {
                            caption: 'Acronis True Image 2020',
                            id: 'acronis-true-image-2020',
                        },
                        name: SCardsSmall,
                        data: CardsSmallIcon.args,
                    },
                ],
            },
        ],
    },
};

export const Counter = {
    args: {
        type: 'tabs',
        isWide: true,
        sticky: false,
        stickyTopOffset: 58,
        stickyMobileTopOffset: 0,

        title: 'Counter example',
        lead: 'Example showing slices with counters enabled.',

        slices: [
            {
                info: {
                    caption: 'Acronis True Image 2020',
                    id: 'acronis-true-image-2020',
                },
                name: SCardsSmall,
                data: {
                    ...CardsSmallIcon.args,
                    counter: true,
                },
            },
            {
                info: {
                    caption: 'Acronis Backup',
                    id: 'acronis-backup',
                },
                name: SCardsSmall,
                data: {
                    ...CardsSmallLogo.args,
                    counter: true,
                },
            },
        ],
    },
};
